module.exports = __webpack_public_path__ + "static/img/caiyuncover.d71fcea5.png";